import { Expose } from 'class-transformer';

export class AbsenceReasonModel {
  public id: number | null = null;
  public name = '';
  @Expose({ name: 'is_working_time' })
  public isWorkingTime = true;
}
